import { Component, OnInit } from '@angular/core';
import { SharedContactService } from '../../shared-contact.service';
import { ActivatedRoute } from '@angular/router';

import { PromptingService } from 'src/app/shared/services';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-contacts-profile-head',
  templateUrl: './contacts-profile-head.component.html',
})
export class ContactsProfileHeadComponent implements OnInit {
  constructor(
    public sharedContactService: SharedContactService,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private prompting: PromptingService,
  ) {}

  ngOnInit(): void {}

  async deleteContact(contact: any) {
    this.prompting
      .confirm(
        {
          allowOutsideClick: false,
          input: 'checkbox',
          inputPlaceholder: `I understand that I'll permanently lose this <strong class="text-danger">contact and all associated data</strong>`,
          title: 'Are you sure want to delete?',
          html: `Are you sure want to delete <strong>${contact.name}</strong>.`,
          confirmButtonText: 'Delete',
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            await this.sharedContactService.deleteContact(
              contact.id,
              contact.type,
            );
            return true;
          },
          inputValidator: (result) => {
            return !result && 'You need to agree';
          },
          didOpen: () => {
            const confirmButton =
              this.prompting.getConfirmButton() as HTMLButtonElement;
            const checkbox = this.prompting.getInput() as HTMLInputElement;

            if (confirmButton && checkbox) {
              confirmButton.disabled = !checkbox.checked;
              checkbox.addEventListener('change', () => {
                confirmButton.disabled = !checkbox.checked;
              });
            }
          },
          isDanger: true,
        },
        'lg',
      )
      .then((res) => {
        if (res.isConfirmed) {
          this.toastr.success('Done!', 'Contact Deleted Successfully');
          this.router.navigate(['/dashboard/contact']);
        }
      });
  }

  onContactUpdated(contactData: any) {
    // Update the contact data directly from the response
    // Backend might return full detailed contact { contact: ..., stats: ..., extraData: ... } 
    // or just the contact object depending on which endpoint was hit.
    if (contactData && contactData.contact) {
      this.sharedContactService.updateCurrentContact(contactData.contact);
    } else {
      this.sharedContactService.updateCurrentContact(contactData);
    }
  }
}
